import React from 'react';
import PropTypes from 'prop-types';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import ContactMenu from '../../components/menus/Contact';
import ContactBanner from '../../components/ContactBanner';
import { colors } from '../../styles';

const styles = css`
  .LeadContent_wrapper {
    display: block;
    width: 100%;
    background-color: #F5F5F5;
    padding-top: 35px;
    padding-bottom: 35px;
    @media (min-width: 992px) {
      padding-top: 70px;
      padding-bottom: 70px;
    }
  }
  .PageContent_wrapper {
    padding-top: 35px;
    padding-bottom: 35px;
    @media (min-width: 992px) {
      padding-top: 70px;
      padding-bottom: 70px;
    }
  }
  .PageSection_wrapper {
    padding-top: 15px;
    padding-bottom: 15px;
    @media (min-width: 992px) {
      padding-top: 35px;
      padding-bottom: 35px;
    }
  }
  .PageTitle_wrapper {
    display: block;
    width: 100%;
    margin-bottom: 30px;
  }
  .PageTitle {
    font-weight: 800;
    text-transform: uppercase;
    font-size: 16px;
    color: #1A1A17;
    letter-spacing: 4px;
    @media (min-width: 992px) {
      font-size: 20px;
      letter-spacing: 6.51px;
    }
  }
  .PagePreTitle {
    display: block;
    text-transform: none;
    font-weight: 300;
    font-size: 35px;
    color: ${colors.color2};
    letter-spacing: 0.25px;
    line-height: 35px;
    margin-bottom: 5px;
    @media (min-width: 992px) {
      font-size: 50px;
      line-height: 50px;
      margin-bottom: 15px;
    }
  }
  .TitleDog {
    display: block;
    width: 75px;
    height: 3px;
    background: #CFCFCD;
    margin: 15px 0;
    @media (min-width: 992px) {
      margin: 20px 0;
    }
  }
  .LeadCopy {
    font-weight: 300;
    font-size: 16px;
    color: #656565;
    letter-spacing: 0;
    line-height: 26px;
    margin-bottom: 30px;
    @media (min-width: 992px) {
      font-size: 20px;
      line-height: 34px;
      letter-spacing: 0.4px;
    }
  }
  .LeadCopyWrapper {
    @media (min-width: 768px) {
      padding: 0 60px 0 0;
    }
  }
  .PageImageWrapper {
    margin-top: 15px;
  }
  .PageImage {
    width: 100%;
  }
  .BodyTitle {
    display: block;
    text-transform: none;
    font-weight: 500;
    font-size: 30px;
    color: ${colors.color2};
    letter-spacing: 0.25px;
    margin-bottom: 15px;
  }
  .BodyCopy p {
    font-size: 16px;
    line-height: 27px;
    @media (min-width: 768px) {
    font-size: 18px;
    color: #656565;
    letter-spacing: 0.3px;
    line-height: 32px;
    }
  }
`;

function Terms({ page }) {
  return (
    <PageWrapper className={styles}>
      <PageHelmet page={page} />
      <InsideHeader
        title={`${page.meta.name}`}
        postTitle="Lorem ipsum dolor sit amet"
        background={get(page, 'page_image.contentUrl')}
      />
      <ContactMenu />
      <div className="LeadContent_wrapper">
        <div className="container">
          <div className="row">
            <div className="LeadCopyWrapper col-12">
              <div dangerouslySetInnerHTML={SanitizeHtml(get(page, 'lead_copy'))} className="LeadCopy" />
            </div>
          </div>
        </div>
      </div>
      <ContactBanner />
    </PageWrapper>
  );
}

Terms.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'terms',
})(Terms);



// WEBPACK FOOTER //
// ./src/pages/Terms/index.js